import { render, staticRenderFns } from "./IngestToggle.vue?vue&type=template&id=2813a29c&scoped=true"
import script from "./IngestToggle.vue?vue&type=script&lang=js"
export * from "./IngestToggle.vue?vue&type=script&lang=js"
import style0 from "./IngestToggle.vue?vue&type=style&index=0&id=2813a29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813a29c",
  null
  
)

export default component.exports